import { render, staticRenderFns } from "./guideOrTravelList.vue?vue&type=template&id=2252d6e6&scoped=true"
import script from "./guideOrTravelList.vue?vue&type=script&lang=js"
export * from "./guideOrTravelList.vue?vue&type=script&lang=js"
import style0 from "./guideOrTravelList.vue?vue&type=style&index=0&id=2252d6e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2252d6e6",
  null
  
)

export default component.exports